import {moveKey, deleteKey} from 'utils/objectMover.js';

export default superclass => class extends superclass  {
    get currentPattern() {
        if (this.context === undefined) {
            return 0;
        }

        if (this.context.track && this.context.track.currentPattern !== undefined) {
            if (this.context.track.instrumentRack) {
                return this.context.track.instrumentRack.currentPattern;
            }
            return this.context.track.currentPattern;
        } else if (this.context.lfosTrack) {
            return this.context.lfosTrack.currentPattern;
        } else if (this.context.envelopesTrack) {
            return this.context.envelopesTrack.currentPattern;
        } else if (this.context.sequencerEngine) {
            return this.context.sequencerEngine.currentPattern;
        } else if (this.context.subSequence) {
            let state = this.store.getState();
            return state.sequencer.currentPattern[this.context.subSequence.id];
        } else {
            return undefined;
        }
    }

    deletePattern(i) {
        this.patternToValue = deleteKey(i, this.patternToValue);
    }

    movePatternTo(from, to) {
        this.patternToValue = moveKey(from, to, this.patternToValue);
    }

    newPattern(patternToCopy, newPatternNumber) {
        this.patternToValue[newPatternNumber] = this.patternToValue[patternToCopy];

        if (this.patternToAutomation[patternToCopy]) {
            this.patternToAutomation[newPatternNumber] =
                this.patternToAutomation[patternToCopy].getCopy(this.store);
        } else {
            this.patternToAutomation[newPatternNumber] =
                this.automation.getCopy(this.store);
        }
        this.patternToAutomation[newPatternNumber].updateRedux();
    }

    isPatternLocked() {
        if (!this.automatable) {
            return false;
        }

        if (this.isAlwaysLocked) {
            return true;
        }

        if (this.context === undefined) {
            return false;
        }
        let locked = false;
        if (this.context.track) {
            if (this.context.track.instrumentRack) {
                locked = this.context.track.instrumentRack.patternLocked;
            }
            locked = this.context.track.patternLocked;
        } else if (this.context.lfosTrack) {
            locked = this.context.lfosTrack.patternLocked;
        } else if (this.context.envelopesTrack) {
            locked = this.context.envelopesTrack.patternLocked;
        } else if (this.context.sequencerEngine) {
            locked = this.context.sequencerEngine.patternLocked;
        }

        let effect = this.context.subDevice ||
            this.context.effect ||
            this.context.midiEffect;
        if (effect) {
            // if it's an effect, first check if that effect is locked
            return effect.locked || locked;
        }
        return locked;
    }

    deleteLocks() {
        if (this.currentPattern in this.patternToValue) {
            this.unlockedValue = this.patternToValue[this.currentPattern];
        } 
        
        this.patternToValue = {};
        this.patternToValue[this.currentPattern] = this.unlockedValue;
    }

    hasPatternLockedValues(oldPattern, patternNumber) {
        if (patternNumber === undefined) {
            return Object.keys(this.patternToValue).length > 0 ||
                Object.keys(this.patternToAutomation).length > 0;
        } else {
            let valueToChange = isNullOrEmpty(this.patternToValue[patternNumber]) ?
                this.unlockedValue : this.patternToValue[patternNumber];
            let oldValue = isNullOrEmpty(this.patternToValue[oldPattern]) ?
                this.unlockedValue: this.patternToValue[oldPattern];

            /*
            if (isNaN(valueToChange) || isNaN(oldValue)) {
                let automationToChange = this.patternToAutomation[patternNumber];
                if (automationToChange !== this.automation) {
                    automationToChange = automationToChange || this.automation;
                    return automationToChange.length > 0;
                }
                return false;
            }
            */

            if (valueToChange !== oldValue) {
                return true;
            }

            let auto = this.automation;
            let toAutomation = this.patternToAutomation[patternNumber] || this.unlockedAutomation;
            let fromAutomation = this.patternToAutomation[oldPattern] || this.unlockedAutomation;
            if (toAutomation !== fromAutomation) {
                return fromAutomation.length > 0 || toAutomation.length > 0;
            }
            return false;
        }
    }
}

const isNullOrEmpty = (x) => x === undefined;
